import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Transition,
} from '@headlessui/react';
import { Fragment } from 'react';

import { RosterRequestType } from '../../generated/graphql';
import { useUserRole } from '../../hooks/useUserRole';
import { useAppSelector } from '../../store/store';
import { ButtonLink } from '../Button';

type Props = {
  children: JSX.Element;
  selectedRows?: string[];
  disabled?: boolean;
};

export default function NewRosterRequestsMenu({
  children,
  selectedRows,
  disabled = false,
}: Props) {
  const routeState = {
    rosterRoomAssignmentIds: selectedRows ?? [],
  };

  const { canCreateGroupRequests } = useUserRole();
  const { rosterRequestType } = useAppSelector((state) => state.enums);

  const menuItems = Object.entries(rosterRequestType || {})
    .filter(([, { value }]) => {
      // Always filter out NEW_RESERVATION (existing logic)
      if (value === RosterRequestType.NewReservation) return false;

      // Filter out group-related request types for travelers
      if (
        !canCreateGroupRequests &&
        value === RosterRequestType.NewGroupReservation
      ) {
        return false;
      }

      return true;
    })
    .map(([key, { value, label }]) => (
      <MenuItem key={key}>
        <ButtonLink
          to="/requests/change"
          state={{
            ...routeState,
            requestType: value,
          }}
          text={label}
        />
      </MenuItem>
    ));

  return (
    <Menu as="div" className="relative w-full">
      <MenuButton as="div">{children}</MenuButton>
      {!disabled && (
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <MenuItems className="absolute bottom-full right-0 z-20 mb-2 flex origin-bottom-right flex-col bg-white shadow-lg sm:bottom-auto sm:top-0 sm:mt-2 sm:origin-top-right">
            {menuItems}
          </MenuItems>
        </Transition>
      )}
    </Menu>
  );
}
